import gql from 'graphql-tag'

export const GIVE_USER_FEEDBACK = gql`
  mutation giveUserFeedback($input: GiveUserFeedbackInput!) {
    giveUserFeedback(input: $input) {
      errors {
        code
        field
        message
      }
    }
  }
`
